"use client";
import { ReactNode, useEffect } from "react";
import Portal from "@/components/globalPortal";
import { BdCloseCircle } from "solar-icon-react/bd";
import { useLockBodyScroll } from "@uidotdev/usehooks";

interface SampleInquiryModalProps {
  onClose: () => void;
  title: string;
  children: ReactNode;
}

const SampleInquiryModal = ({
  onClose,
  title,
  children,
}: SampleInquiryModalProps) => {
  useLockBodyScroll();

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return (
    <Portal>
      <div
        className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/50 px-4 py-8"
        onClick={onClose}
      >
        <div
          className="relative my-auto w-full max-w-lg rounded-2xl bg-white shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between rounded-t-2xl bg-primary-main px-6 py-4">
            <h2 className="font-bold text-white">{title}</h2>
            <BdCloseCircle
              onClick={onClose}
              size={24}
              className="cursor-pointer text-white!"
            />
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    </Portal>
  );
};

export default SampleInquiryModal;
